<template>
  <component
    :is="containerComponent"
    class="brb-pagination"
    v-animate-css="animation"
  >
    <b-pagination
      v-if="total > perPage"
      v-model="page"
      :per-page="perPage"
      :total-rows="total"
      class="m-0 p-0"
      pills
    />
  </component>
</template>

<script>
export default {
  name: 'BrbPagination',
  props: {
    total: {
      type: [Number, String],
      required: true
    },
    perPage: {
      type: [Number, String],
      required: true
    },
    currentPage: {
      type: [Number, String],
      required: true
    },
    scrollInId: String,
    scrollInClass: String,
    scrollSpace: {
      type: Number,
      default: 0
    },
    containerComponent: {
      type: String,
      default: 'div'
    },
    animation: {
      type: String,
      default: 'slideInUp'
    },
    doNotSyncUrl: Boolean
  },
  computed: {
    page: {
      get() {
        return this.currentPage
      },
      set(page) {
        this.$emit('update:currentPage', page)
        this.syncUrl()
        this.scrollToTop()
      }
    },
    effectiveReloadData() {
      return `${this.currentPage}, ${this.perPage}`
    }
  },
  watch: {
    total: {
      handler(total) {
        if (total <= this.perPage && this.currentPage > 1) {
          this.$emit('update:currentPage', this.currentPage - 1)
          this.syncUrl()
          this.scrollToTop()
        }
      },
      immediate: true
    },
    effectiveReloadData() {
      this.$emit('reload', {
        currentPage: this.currentPage,
        perPage: this.perPage,
        total: this.total
      })
    }
  },
  methods: {
    scrollToTop() {
      if (process.browser && window !== 'undefined' && document !== 'undefined')
        if (this.scrollInId || this.scrollInClass) {
          const scrollInElement = this.scrollInId
            ? document.getElementById(this.scrollInId)
            : document.getElementsByClassName(this.scrollInClass)[0]

          if (scrollInElement) {
            window.scrollTo({
              top: scrollInElement.offsetTop - this.scrollSpace,
              behavior: 'smooth'
            })
          }
        } else {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })
        }
    },
    syncUrl() {
      if (this.doNotSyncUrl) return
      this.$nextTick(() => {
        const query = { ...this.$route.query }

        if (this.currentPage > 1) {
          query.page = this.currentPage
        } else if (Object.prototype.hasOwnProperty.call(query, 'page')) {
          delete query.page
        }

        this.$router.push({
          path: this.$route.path,
          query
        })
      })
    }
  }
}
</script>

<style lang="scss">
@import '../../../assets/scss/components/brb-components/_brb-pagination.scss';
</style>
